
import React, { Component, useState } from 'react';
import {Sidebar} from '../common/Sidebar';
import {Dropdown} from 'semantic-ui-react';
import axios from 'axios';
import {AppContext} from '../../context/app/appContext';
import {BlogImageUpload} from './iconUpload';
export const AddBlog = (props) => {
    const [blogHeading, setBlogHeading] = useState();
    const [blogImage, setBlogImage] = useState();
    const [imgurl, setImgurl] = useState()
    const [paraNumber, setParaNumber] = useState(1)
    const [paraTemp, setParaTemp] = useState();
    const [paraValues, setParaValues] = useState([])
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    // const imgURL = 'https://perkfix-blog-images.s3.us-east-2.amazonaws.com/taxidermi.jpg'
    const paragraphFunction = ()=> {
        const map = []
        for(let i = 1; i<=paraNumber; i++){
            map.push(
                <div>
                    <div>Type Paragraph: (Make sure this is free of typos) {paraNumber}</div>
                    <textarea type="text" className="blogInput" name="blogParagraph" style={{width: "70%", height: 100}} onChange={(e)=>setParaTemp(e.target.value)}></textarea>
                    <button className="cancel-button" onClick={() => setParaValues([...paraValues, paraTemp])}>Done?</button>
                </div>
            )
            // setParaValues([...paraValues, paraTemp])
        }
        return map
    }
    const sendBlog = async () => {
        console.log("blog sending code")
        const paragraphs = paraValues
        const heading = blogHeading
        const imgURL = imgurl
        var token = localStorage.getItem('accessToken')
        const res = axios.post(baseURL + '/blog/upload',{
            heading: heading,
            imgURL: imgURL,
            paragraphs: paragraphs
        },{headers : {
            Authorization: "Bearer "+token}
        })

        console.log("BLog saved = ", res)
        window.location.reload(false)

    }
    return(
        <React.Fragment>
            <div>NOTE: PLEASE FOLLOW A TOP DOWN APPROACH.</div>
            <div>Type heading:</div>
            <input type="text" className="blogInput" name="blogName" onChange={(e)=>setBlogHeading(e.target.value)}></input>

            <div>Image Name: (Make sure this is unique.)</div>
            <input type="text" className="blogInput" name="blogImageName" onChange={(e)=>setBlogImage(e.target.value)}></input>

            {/* <div>Type Paragraph: (Make sure this is free of typos) {paraNumber}</div>
            <input type="text" className="blogInput" name="blogParagraph" onChange={(e)=>setBlogHeading(e.target.value)}></input> */}
            {paragraphFunction()}
            <button className="cancel-button" onClick={() => setParaNumber(paraNumber+1)}>Add Paragraph</button>
            <BlogImageUpload imageName={blogImage} setImgurl={setImgurl}/>
            <div className="perk-buttons">
                    <button className="cancel-button" onClick={() => window.location.reload(false)}>Cancel</button>
                    <button className="add-choices-button" onClick={() => sendBlog()}>Publish Blog</button>
                
            </div>
        </React.Fragment>


    )
}